module.exports = __webpack_public_path__ + "img/headerlogo.cddc9b2b.png";